import React, { useState } from "react";
import { IGGCargoMachinList } from "./CargoMachinaryDetails/IGGCargoMachinList";
import { BWTCargoMachinList } from "./CargoMachinaryDetails/BwtsCargoMachinList";
import { CargoCraneList } from "./CargoMachinaryDetails/CargoCranList";
import { LpgCargoList } from "./CargoMachinaryDetails/LpgCargoList";
import { LngCargoCompressorList } from "./CargoMachinaryDetails/LngCargoCompressureList";
import { NitrogenPlantList } from "./CargoMachinaryDetails/NitrogenPlantList";
import { CoptList } from "./CargoMachinaryDetails/CoptList";
import { FramoList } from "./CargoMachinaryDetails/FramoList";
import SubMachinaryTab from "./SubMachinaryTab";
import CargoRemarks from "./CargoRemarks";

export const SubTabCargoMachin = ({ id }) => {
  const [activeTab, setActiveTab] = useState("BWTS");

  const handleClick = (name) => {
    setActiveTab(name);
    localStorage.setItem("engineLogbook", name);
  };

  return (
    <>
      <div className="white-containers">
        <ul className="sub-marine-tabs">
          <li className={activeTab === "BWTS" ? "active" : ""} onClick={() => handleClick("BWTS")}>
            BWTS
          </li>
          <li className={activeTab === "IGG" ? "active" : ""} onClick={() => handleClick("IGG")}>
            IGG
          </li>

          <li
            className={activeTab === "CargoCrane" ? "active" : ""}
            onClick={() => handleClick("CargoCrane")}
          >
            Cargo Crane
          </li>
          <li
            className={activeTab === "LpgCargoCompressor" ? "active" : ""}
            onClick={() => handleClick("LpgCargoCompressor")}
          >
            LPG Cargo Compressor
          </li>
          <li
            className={activeTab === "LngCargoCompressor" ? "active" : ""}
            onClick={() => handleClick("LngCargoCompressor")}
          >
            LNG Cargo Compressor
          </li>
          <li
            className={activeTab === "NitrogenPlant" ? "active" : ""}
            onClick={() => handleClick("NitrogenPlant")}
          >
            Nitrogen Plant
          </li>

          <li className={activeTab === "Copt" ? "active" : ""} onClick={() => handleClick("Copt")}>
            Copt
          </li>
          <li
            className={activeTab === "Framo" ? "active" : ""}
            onClick={() => handleClick("Framo")}
          >
            Framo
          </li>
          <li
            className={activeTab === "CargoRemarks" ? "active" : ""}
            onClick={() => handleClick("CargoRemarks")}
          >
            Remarks
          </li>
        </ul>
      </div>
      <div className="white-container-contant">
        {activeTab == "BWTS" && <BWTCargoMachinList id={id} />}
        {activeTab == "IGG" && <IGGCargoMachinList id={id} />}
        {activeTab == "CargoCrane" && <CargoCraneList id={id} />}
        {activeTab == "LpgCargoCompressor" && <LpgCargoList id={id} />}
        {activeTab == "LngCargoCompressor" && <LngCargoCompressorList id={id} />}
        {activeTab == "NitrogenPlant" && <NitrogenPlantList id={id} />}
        {activeTab == "Copt" && <CoptList id={id} />}
        {activeTab == "Framo" && <FramoList id={id} />}
        {activeTab == "CargoRemarks" && <CargoRemarks id={id} />}
      </div>
    </>
  );
};
